import { defineComponent as _defineComponent } from 'vue';
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue";
const _hoisted_1 = { class: "df-step" };
const _hoisted_2 = { class: "df-step__head" };
const _hoisted_3 = {
    key: 0,
    class: "df-step__title",
    tabindex: "-1"
};
const _hoisted_4 = {
    key: 1,
    class: "df-step__sub"
};
const _hoisted_5 = { class: "df-step__body" };
const _hoisted_6 = {
    key: 0,
    class: "df-step__actions"
};
export default /*@__PURE__*/ _defineComponent({
    __name: 'StepShell',
    props: {
        title: {},
        subtitle: {}
    },
    setup(__props) {
        // SYNC: see ../../_SYNC.md.
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("header", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "head", {}, () => [
                        (__props.title)
                            ? (_openBlock(), _createElementBlock("h1", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true),
                        (__props.subtitle)
                            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.subtitle), 1 /* TEXT */))
                            : _createCommentVNode("v-if", true)
                    ])
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _renderSlot(_ctx.$slots, "default")
                ]),
                (_ctx.$slots.actions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _renderSlot(_ctx.$slots, "actions")
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
